<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
        <div
          :class="`vx-row ${filtroAvancado == true ? 'mb-5' : 'pb-12 mb-2'}`"
        >
          <div class="vx-col sm:w-1/3 w-full">
            <span>Responsável</span>
            <v-select
              :options="usuarios"
              name="setor"
              id="setor"
              multiple
              v-model="formFiltro.usuarioResponsavel"
              :state="validateState('setor')"
              :class="validateClass('setor')"
            ></v-select>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <span>Placa / Chassi</span>
            <vs-input
              class="w-full"
              name="Placa"
              id="Placa"
              v-model="formFiltro.placa"
              :state="validateState('Placa')"
              :danger="validateClass('Placa')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <span>Status</span>
            <v-select
              :options="status"
              multiple
              name="Status"
              id="Status"
              v-model="formFiltro.status"
              :state="validateState('Status')"
              :class="validateClass('Status')"
            ></v-select>
          </div>
        </div>

        <div class="vx-row pb-12 mb-2">
          <div class="vx-col sm:w-1/2 w-full">
            <span>Data Inicial</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataInicial"
            ></datepicker>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <span>Data Final</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataFinal"
            ></datepicker>
          </div>
        </div>
      </form>
      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row vs-justify="flex-end">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            native-type="submit"
            @click="buscar"
            >Buscar</vs-button
          >
          <vs-button
            @click="filtroAvancado = !filtroAvancado"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>
          <vs-button
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import swal from 'sweetalert';
import vSelect from 'vue-select';
import cpfCnpj from '../../services/cpfCnpj';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import { decryptData } from '../../services/decryptData';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
  },
  watch: {
    estado(value) {
      this.formFiltro.estado = value;
      this.formFiltro.cidade = null;
      if (value != null) {
        this.buscaDadosSelectsCidades(
          'domMunicipio',
          'cidades',
          'nomeCidade',
          'idCidade',
        );
      }
    },
  },
  data() {
    return {
      filtroAvancado: false,
      idEmpresa: null,
      estados: [],
      cidades: [],
      usuarios: [],
      status: [],
      languages: lang,
      estado: null,
      formFiltro: {
        idEmpresa: null,
        placa: '',
        nomeAssociado: '',
        dataInicial: this.dataInicio(),
        dataFinal: this.dataFim(),
        status: null,
        setor: null,
        nome: '',
      },
    };
  },
  methods: {
    formataData(data) {
      return moment(data).format('YYYY-MM-DD');
    },
    limparFiltro() {
      this.formFiltro = {
        idEmpresa: null,
        placa: '',
        nomeAssociado: '',
        dataInicial: this.dataInicio(),
        dataFinal: this.dataFim(),
        status: null,
        setor: null,
        nome: '',
      };
      this.buscar();
    },
    dataFim() {
      var a = new Date();
      var b = a.setDate(a.getDate() + 1);
      //return this.formataData(b);
      return b;
    },
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 30);
      //return this.formataData(b);
      return b;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5 ||
              element[campoPK] == 7
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscaDadosUsuarios() {
      service
        .getAll('Usuario', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            this.usuarios.push({
              id: element.idUsuario,
              label: element.nome,
            });
          });
        });
    },

    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll('g', {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        });
    },
    buscar() {
      this.formFiltro.idEmpresa = this.idEmpresa;
      console.log('emit', this.formFiltro);
      this.$emit('filtro', this.formFiltro);
    },
  },
  mounted() {
    this.buscaDadosUsuarios();
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    // this.buscaDadosSelects("domStatusCotacao","status","nomeStatus","idStatus");
    this.buscaDadosSelects(
      'domStatusCancelamento',
      'status',
      'nomeStatus',
      'idStatus',
    );
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    'v-select': vSelect,
    Datepicker,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
